import Navigation from "@/components/site/Navigation";
import Hero from "@/components/site/Hero";
import About from "@/components/site/About";
import Services from "@/components/site/Services";
import VideoTour from "@/components/site/VideoTour";
import Gallery from "@/components/site/Gallery";
import Awards from "@/components/site/Awards";
import Testimonials from "@/components/site/Testimonials";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import { useReveal } from "@/lib/reveal";

export default function HomePage() {
  useReveal();
  return (
    <div className="min-h-screen bg-[#F9F8F6] text-[#1C2A24]" data-testid="home-page">
      <Navigation />
      <main>
        <Hero />
        <About />
        <Services />
        <VideoTour />
        <Gallery />
        <Awards />
        <Testimonials />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
